<template>
    <div>
        <Breadcrumbs main="Sliders" title="Slider "/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                              
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.sliderModal >
                                
                                <i class="icon-shopping-car"> </i> Add Slider</a
                              >
                              <!-- <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                              <!-- <b-form-group  label-cols="4" content-cols="4" :label="`Apply to (${selected.length})`" class="mb-0 datatable-select">
                                  <b-form-select @input="applyTo" style="width:100px" v-model="select" :options="selectOptions"></b-form-select>
                              </b-form-group> -->
                            </div>

                          </b-col>
                      </b-row>

                      <b-modal id="shopModal" size="lg" ref="shopModal" :title="'View Shop Profiles : '+shopTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="shopTable"
                                :items="allShops"
                                :fields="shopfields"
                                :per-page="perShopPage"
                              >
                                  <template #cell(shop)="row">
                                    <span style="font-weight:500;" class="txt-primary">
                                      {{ row.item.shop }}
                                    </span>
                                </template>
                                
                                <template #cell(user)="row">

                                  <a style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                      {{ row.item.user.countryCode+row.item.user.tel }}
                                    </a>
                                </template>

                                <template #cell(preferences)="row">

                                    <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="pref in row.item.preferences" :key="pref">
                                        {{ pref }}
                                    </div>

                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>


                            <b-modal id="addGroupModal" size="md" ref="addGroupModal" :title="`Group (${selected.length}) Customers`" ok-title="Done" class="theme-modal">

                                <form id="alertForm" @submit.stop.prevent="groupCustomers" class="p-2 px-3">

                                  <div class="form-group ">
                                    <label class="col-form-label" type="text" for="recipient-name">Select Group:</label>
                                    <!-- <b-form-input v-model="group.group" placeholder="Group"></b-form-input> -->
                                    <b-form-select required v-model="select" :options="allGroups"></b-form-select>
                                  </div>
                                  <div class="form-group ">
                                  <label class="col-form-label" type="text" for="recipient-name">Selected Customers:</label>
                                    <div class="form-group mt-2">  

                                        <div class="btn btn-primary btn-xs btn-pill mr-2 mb-2" v-for="cus in selected" :key="cus._id">
                                                {{ cus.name }} 
                                                <!-- - {{ cus.phone.countryCode+cus.phone.tel }} -->
                                        </div>

                                    </div>
                                  </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>

                                </form>
                              </b-modal>


                      <b-modal id="sliderModal" size="md" ref="sliderModal" title="Add Slider" ok-title="Done" class="theme-modal">

                                <template #modal-header>
                                    <h5>{{ editSlider ? 'Edit Slider : '+editSlider : 'Add Slider' }} </h5>
                                    
                                </template>

                                <form id="alertForm" @submit.stop.prevent="submitSlider" class="p-2 px-3">

                                    <figure v-if="productFile" class="b-image-wrapper image is-2by1 m-1">
                                    <!-- <b-aspect aspect="2:1"> -->
                                        <b-img
                                            rounded
                                            :src="pro"
                                            style="width:100%;height:217px;object-fit:cover"
                                        >
                                        </b-img>
                                    <!-- </b-aspect>     -->
                                    </figure>

                                    <div class="form-group mt-2">
                                      <label class="col-form-label" type="text" for="recipient-name">Shop: <span class="txt-primary">( Name / Business Name )</span></label>

                                      <b-form-select v-model="slider.shop" :options="shops" required></b-form-select>
                                      
                                      <!-- <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                v-model="slider.shop"
                                                placeholder="Shop Name">
                                            </b-form-input> -->
                                    </div>

                                    <div class="row form-group mt-2">
                                        
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name"> Image: <span class="txt-primary"></span></label>
                                            <b-form-file accept="image/jpeg, image/png" v-model="productFile" ></b-form-file>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            
                                            <label class="col-form-label" for="recipient-name">Slider Text: </label>
                                            <b-form-input 
                                                required
                                                v-model="slider.text"
                                                placeholder="Slider Text">
                                            </b-form-input>
                                              
                                          </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Link:</label>
                                          <b-form-input 
                                            v-model="slider.link" 
                                            placeholder="link ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Param:</label>
                                          <b-form-input 
                                            v-model="slider.params" 
                                            placeholder="Param ">
                                          </b-form-input>
                                        </div>
                                    </div>

                                  <div class="form-group row">
                                    <div class=" col-6">
                                      <label class="col-form-label" for="">Start Date</label>
                                      <b-form-datepicker
                                            v-model="slider.start" 
                                            placeholder="Start Date">
                                        </b-form-datepicker>
                                    </div>
                                    <div class=" col-6">
                                      <label class="col-form-label" for="">End Date</label>
                                      <b-form-datepicker
                                            v-model="slider.end" 
                                            placeholder="End Date">
                                        </b-form-datepicker>
                                      </div>
                                  </div>
                                  <div class="form-group row pb-3">
                                    <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Exipry:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="slider.expiry" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Visible:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="slider.visible" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                    <!-- <label class="col-form-label" type="text" for="recipient-name">Link:</label>
                                    <b-form-input v-model="alert.link" placeholder="Alert Link"></b-form-input> -->
                                  </div>
                                    <b-button block  type="submit" :disabled="submitting" variant="primary">Submit</b-button>

                                </form>
                            </b-modal>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-item @click="del(row.item)">Delete</b-dropdown-item>
                              <!-- <b-dropdown-item @click="view(row.item)">View </b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>

                          <template #cell(img)="row">

                            <a :href="row.item.img" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.img"
                                                style="width:200px;height:100px;object-fit:cover"
                                            >
                                            </b-img>
                                        </a>
                           </template>
        

                          <template #cell(active)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.active ? 'Active' : 'Inactive') }}
                              </div>
                          </template>


                          <template #cell(visible)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="visible(row.item)" title="Click to change visibility" :class="`btn ${ (row.item.visible ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.vis }}
                              </div>
                          </template>

                          <template #cell(expiry)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="expiry(row.item)" title="Click to change expiry status" :class="`btn ${ (row.item.expiry ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.exp }}
                              </div>
                          </template>
                    

                          <template #cell(start)="row">
                            <span v-if="row.item.start" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.start).toDateString().substring(4) }} </span>
                          </template>

                          <template #cell(end)="row">
                            <span v-if="row.item.end" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.end).toDateString().substring(4) }} </span>
                          </template>

                          <template #cell(date)="row">
                                <!-- {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }} -->
                                {{ row.item.date }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ totalRows.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      requestLoading: false,
      submitting: false,
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      shopTitle: '',
      editSlider: false,
      productFile: null,
      dropFile: null,
      pro: '',
      slider: {
        shop: null,
        img: '',
        text: '',
        link: '',
        params: '',
        start: null,
        end: null,
        expiry: false,
        visible: true,
      },
      alert: {
        icon: 'bell',
        type: null,
        to: 'Shops',
        shop: '',
        user: '',
        message: '',
        link: '',
        description: ''
      },
      users: [],
      shops: [],
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      toOptions: ['Users', 'Shops', 'Both'],
      tablefields: [
        { key: 'text', label: 'Slider Text', sortable: true, },
        { key: 'img', label: 'Slider Image', sortable: true, },
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'link', label: 'Link', sortable: true, },
        { key: 'start', label: 'Start Date', sortable: true, },
        { key: 'end', label: 'End Date', sortable: true, },
        { key: 'expiry', label: 'Expiry', sortable: true, },
        { key: 'visible', label: 'Visible', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      shopfields: [
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'preferences', label: 'Preferences', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      allShops: [],
      allGroups: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'createdAt',
      sortDesc: true,
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      groupfields: [
        { key: 'group', label: 'Group', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      sortGroupBy: 'product',
      currentGroupPage: 1,
      totalGroupRows: 1,
      perGroupPage: 5,
      totalShopRows: 1,
      perShopPage: 5,
      selectOptions: [
        'Group',
      ],
      select: null,
    }
  },
  components: {
    
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    },
    getUser() {
      return this.$store.getters['authentication/getUser']
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

    //  const url = this.userAdmin ? '/alerts/' : '/users/'+this.getUser.name

      axios.get('/sliders/')
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length

          for (let index = 0; index < this.items.length; index++) {

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                  // this.items[index].date = (new Date(this.items[index].createdAt)).toDateString().substring(4)
                    
                }

                // visible
                if (this.items[index].visible) {
                  this.items[index].vis = 'Yes'
                } else {
                  this.items[index].vis = 'No'
                }


                // expiry
                if (this.items[index].expiry) {
                  this.items[index].exp = 'Yes'
                } else {
                  this.items[index].exp = 'No'
                }
            }
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        axios.get('/shop/').then(response=>{
          //
          const data = response.data
          data.sort((a,b) =>  a.name.localeCompare(b.name))

          this.shops = data.map(sh => ({ text: sh.name, value: sh.name }))
          this.shops.push({ value: null, text: 'Select a Shop'})

        })

    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    getshops(data) {
        // modal
        this.$refs.shopModal.show()
        //
        this.shopTitle = data.name

        //
        // axios.get('/order/'+data.business).then( response=>{
            let _shop = this.getUser.name

            //
            this.allShops = this.userAdmin ? data.shops : data.shops.filter(shop => shop.shop == _shop)
            this.totalShopRows= this.userAdmin ? data.shops.length : data.shops.filter(shop => shop.shop == _shop).length

        // }).catch(error=>{

        //     console.log(error.response.data)
        // })

    },
    groupCustomers() {
      
      axios.post('/group/customers', { shop: this.getUser.name, group: this.select, customers: this.selected }).then(response=> {

            this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        this.fetchData()
        //
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    submitSlider() {

    this.submitting = true

      let url
      let method

      if (this.editSlider) {
        url = '/slider/'+this.editSlider
        method = axios.patch;
      } else {
        url = '/slider/'
        method = axios.post;
      }


      const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload/'
      // upload to cloudinary first
      if (this.productFile || this.slider.img){
          //
          const formData = new FormData()
          formData.append('upload_preset', 'qwwhqvhe')
          formData.append('folder', 'shopnscan/sliders/')
          // formData.append('public_id', this.dropFile.name)
          formData.append('file', this.productFile)

          // 
          if (this.slider.img && !this.productFile) {
            console.log('here')
            //
            method(url, this.slider)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.sliderModal.hide()
                    //
                    this.fetchData()
                    
                    this.submitting = false

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

            return
          }

          fetch(cloudURL, {
              method: 'POST',
              body: formData
          }).then(async response=> {
                
                const data = await response.json()

                if (!response.ok) {
                    const error = (data && data.message) || response.status
                    return Promise.reject(error)
                }

                //
                this.slider.img = data.secure_url

                method(url, this.slider)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.sliderModal.hide()
                    //
                    this.submitting = false
                    //
                    this.fetchData()
                    

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

          })

      }

    //   method(url, { shop: this.getUser.name, group: this.group.group, description: this.group.description } )
    //   .then(response=>{
    //     //
    //     this.$swal({
    //       title:"Good job!",
    //       text: response.data,
    //       type:'success'
    //     });

    //     this.fetchData()
    //     //
        
        
    //   })
    //   .catch( e => {
    //     this.$swal({
    //       title:"Failed!",
    //       text: e.response.data,
    //       type:'error'
    //     });
    //   })

    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewVendor = data
      //
    },
    edit(data){

    this.$refs.sliderModal.show()

    this.editSlider = data.text
    //
    const slider = {}
    slider.img = data.img
    slider.shop = data.shop
    slider.text = data.text
    slider.link = data.link
    slider.start = data.start
    slider.end = data.end
    slider.expiry = data.expiry
    slider.visible = data.visible

    this.slider.img = slider.img
    this.slider.shop = slider.shop
    this.slider.text = slider.text
    this.slider.link = slider.link
    this.slider.start = slider.start
    this.slider.end = slider.end
    this.slider.expiry = slider.expiry
    this.slider.visible = slider.visible
    
    //
    
    },
    visible(data) {
      //
      axios.post('/slider/visible', { id: data._id, visible: data.visible ? false : true })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    expiry(data) {
      //
      axios.post('/slider/expiry', { id: data._id, expiry: data.expiry ? false : true })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.vendor.country.name = name.split("(")[0].trim()
        this.vendor.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.vendor.country.code = "+"+dialCode
        this.vendor.phone.countryCode = "+"+dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
    applyTo() {
        //
        this.$refs.sliderModal.show()
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    del(data) {
      this.$swal({
        title: "Delete '"+data.text+"'?",
        text: "Are you sure, You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {

          //
          axios.delete(`/slider/${data._id}`)
          .then(response=>{
            //
            this.$swal({
              title:`Deleted '${data.text}'!`,
              text: response.data,
              type: 'success'
            })
            // delete image from cloud
            

            //
            this.fetchData()
          })
          .catch( e => {
            this.$swal({
              title:"Failed!",
              text: e.response.data,
              type:'error'
            });
          })
          
        }
      })

    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>